<template>
    <base-component :taxpayerInfo="currentTaxpayer">
        <template slot="form">
            <view-log-search-form :fetch="fetchData" />
        </template>
        <template slot="workArea">
            <b-alert variant="danger" :show="showAlert">
                {{ alert }}
            </b-alert>
            <b-card no-body class="flex-fill flex-shrink-0">
                <b-tabs card>
                    <b-tab :title="$t('menu.kkms')" @click="openKkms"></b-tab>
                    <b-tab :title="$t('menu.reports')" active>
                        <b-table :items="views" :fields="fields" class="table-borderless" striped small show-empty>
                            <template slot="viewDate" slot-scope="row">
                                {{ $d(row.item.viewDate, 'long') }}
                            </template>
                            <template slot="creationDate" slot-scope="row">
                                {{ $d(new Date(row.item.creationDate), 'long') }}
                            </template>
                            <template slot="empty">
                                <div class="text-center">
                                    {{ $t('general.noData') }}
                                </div>
                            </template>
                        </b-table>
                    </b-tab>
                    <b-tab v-if="!isOperator" :title="$t('menu.tickets')" @click="openTickets"></b-tab>
                    <b-tab v-if="!isOperator" :title="$t('menu.moneyPlacements')" @click="openMoneyPlacements"></b-tab>
                </b-tabs>
            </b-card>
        </template>
    </base-component>
</template>

<script>
/* eslint-disable */
import AppData from '@/utils/appdata';
const ViewLogSearchForm = () => import('@/components/report/ReportViewLogSearchForm.vue');

export default {
    name: 'ReportViewLog',
    mixins: [ AppData ],
    components: {
        ViewLogSearchForm
    },
    data () {
        return {
            views: []
        }
    },
    mounted () {
        this.getCurrentTaxpayer()
    },
    computed: {
        fields() {
            return [
                { key: 'viewDate', label: this.$t('report.viewLog.viewDate'), sortable: true },
                { key: 'creationDate', label: this.$t('report.createDate'), sortable: true },
                { key: 'reportType', label: this.$t('report.type'), sortable: true },
                { key: 'surname', label: this.$t('person.lastname'), sortable: true },
                { key: 'firstName', label: this.$t('person.firstname'), sortable: true },
                { key: 'patronymic', label: this.$t('person.middlename'), sortable: true },
                { key: 'userRole', label: this.$t('general.role'), sortable: true }
            ]
        }
    },
    methods: {
        fetchData(formData) {
            this.hideAlert();
            
            const onSuccess = response => {
                if (!Array.isArray(response))
                    throw new Error('Server must be returns array');
                
                this.views = response.map(x =>{
                    if (x.viewDate != null)
                        x.viewDate = new Date(x.viewDate);

                    if (x.creationDate != null)
                        x.creationDate = new Date(x.creationDate);
                    
                    return x;
                });

            };

            this.$request.sendRequest(
                this,
                this.$appConfig.apiUrls.report.viewLog,
                formData,
                onSuccess,
                 this.displayAlert);
        },
        openKkms() {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'kkms' })
            } else {
                this.$router.push({ name: 'childKkm' })
            }
        },
        openTickets() {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'tickets' })
            } else if (this.isInspector) {
                this.$router.push({ name: 'childTickets' })
            }
        },
        openMoneyPlacements() {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'moneyPlacements' })
            } else if (this.isInspector) {
                this.$router.push({ name: 'childMoneyPlacements' })
            }
        }
    }
}
</script>
